import ReceptorListStore from './ReceptorListStore';
import ReceptorInfoStore from './ReceptorInfoStore';
import ReceptorUpsertStore from './ReceptorUpsertStore';
import ReceptorUploadStore from './ReceptorUploadStore';
import ReceptorFileListStore from './ReceptorFileListStore';
import ReceptorExcelListStore from './ReceptorExcelListStore';
import ReceptorSuggestionsStore from './ReceptorSuggestionsStore';

const ReceptorStore = {
  list: ReceptorListStore,
  info: ReceptorInfoStore,
  upsert: ReceptorUpsertStore,
  upload: ReceptorUploadStore,
  excel: ReceptorExcelListStore,
  archivos: ReceptorFileListStore,
  suggestions: ReceptorSuggestionsStore,
};

export default ReceptorStore;
